import axios from "axios";

const instance =  axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8000"
});

// Add a request interceptor
instance.interceptors.request.use(config => {

	const xAccessToken = localStorage.getItem("token");
	if(xAccessToken){
		config.headers.common['x-access-token'] = xAccessToken;
	}
	return config;
}, error => {
	console.error('Something happened in setting up the request that triggered an Error', error.message);
	return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(response => {
	if(response.data.data) {
		if(response.data.data.token)
			localStorage.setItem("token", response.data.data.token);
	}

	return Promise.resolve(response.data);
}, error => {
	if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		console.log(error);
		if(error.status === 401){
			localStorage.removeItem("token");
			// const {message} = error;
			// if(message){
			// 	dispatch(show({
			// 		title: "Error",
			// 		message: message
			// 	}, 'error'));
			// }
			// return dispatch(push('login'));
		}

		return Promise.reject(error.response.data);
	} else if (error.request) {
		console.error('The request was made but no response was received', error.request);
		return Promise.reject(error);
	} else {
		console.error('Something happened in setting up the response that triggered an Error', error.message);
		return Promise.reject(error);
	}
});

export default instance;